import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import { CardContent, CardMedia } from '@mui/material';

import { Cinema } from 'api/cinemaClub';
import { Card, Title } from 'common';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import { useLanguage } from '../../../context/LanguageContext'

interface CinemaCardProps {
    cinemaItem: Cinema;
}

export const CinemaCard = ({ cinemaItem }: CinemaCardProps) => {
    const { language } = useLanguage();

    return (
        <Link to={`/cinema-club/${cinemaItem.id}`} style={{ textDecoration: 'none' }}>
            <Card sx={{ maxWidth: 345, marginBottom: 2, border: '1px solid #af0000' }}>
                {cinemaItem.images && cinemaItem.images.length > 0 && cinemaItem.images[0] ? (
                    <CardMedia
                        component="img"
                        sx={{ borderRadius: 1 }}
                        height="200"
                        image={cinemaItem.images[0].photo}
                        alt={cinemaItem.title}
                    />
                ) : (
                    <ImageNotSupportedIcon
                        sx={{
                            height: 200,
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '5rem'
                        }}
                    />
                )}
                <CardContent>
                    <Title
                        gutterBottom
                        variant="h5"
                        component="div"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2, // количество строк, для отображения
                            fontWeight: 600,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {cinemaItem[`title_${language}`]}
                    </Title>
                    <Title
                        gutterBottom
                        variant="body1"
                        color="text.secondary"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 4, // количество строк, для отображения
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        <div dangerouslySetInnerHTML={{
                            __html: cinemaItem[`description_${language}`]
                        }} />
                    </Title>
                    <Title variant="body2" color="text.primary">
                        {dayjs(cinemaItem.created_at).format('DD.MM.YYYY')}
                    </Title>
                </CardContent>
            </Card>
        </Link>
    );
};
